import { ChevronRight, PanelLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path: string;
  category?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  onToggle?: () => void;
  toggled?: boolean;
}

export const Breadcrumb = ({ items, onToggle, toggled }: BreadcrumbProps) => {
  if (items.length === 0) return null;

  const firstItem = items[0];
  const category = firstItem?.category || 'Home';

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-300 px-5 py-3 bg-white dark:bg-gray-900 border-b dark:border-gray-700">
      {onToggle && (
        <button
          onClick={onToggle}
          className="hidden md:block mr-2 p-1 hover:bg-gray-100 rounded-md transition-colors"
          data-testid="sidebar-toggle"
        >
          <PanelLeft
            size={20}
            className={`text-gray-600 transition-transform duration-300 ${toggled ? 'rotate-180' : ''}`}
          />
        </button>
      )}
      <span className="font-semibold text-gray-900 dark:text-white">{category}</span>

      {items
        .filter(item => item.label !== category)
        .map((item, index, filteredItems) => {
          const isLast = index === filteredItems.length - 1;

          return (
            <div key={item.path} className="flex items-center space-x-2">
              <ChevronRight size={16} className="text-gray-400" />
              {isLast ? (
                <span className="font-medium text-gray-900 dark:text-white">{item.label}</span>
              ) : (
                <Link to={item.path} className="hover:text-gray-900 transition-colors">
                  {item.label}
                </Link>
              )}
            </div>
          );
        })}
    </nav>
  );
};
